import type { ApolloError } from '@apollo/client';
import type { Dispatch } from '../../app/redux/useAppSelector';
import { UIActions } from '../../ui/uiSlice';
import handleApolloError from '../../utils/error/handleApolloError';

const handleUnresolveThreadError = (error: ApolloError, dispatch: Dispatch) =>
  handleApolloError(error, 'VALIDATION', () =>
    dispatch(
      UIActions.pushToast({
        level: 'error',
        message:
          'Could not unresolve comment because the commented text has been deleted from the post.',
      }),
    ),
  );

export default handleUnresolveThreadError;
